import { render, staticRenderFns } from "./property-locality-view.vue?vue&type=template&id=7bac020d"
import script from "./property-locality-view.vue?vue&type=script&lang=js"
export * from "./property-locality-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports